<script>
  export default {
    name: 'Achivement',
    computed: {
      n() {
        return this.$store.state.answeredIds.length;
      },
      getText() {
        if (this.n < 5) {
          return 'この調子で質問に答えていきましょう！';
        } else if (this.n < 10) {
          return 'Vitalityライフをもっと聞かせてください！';
        } else if (this.n < 15) {
          return '残り半分も楽しんでいきましょう！';
        } else if (this.n < 20) {
          return 'ラストスパート頑張りましょう！';
        } else {
          return 'おめでとうございます！素晴らしい回答でした！';
        }
      },
      classnames() {
        return {
          'is-shown': this.n > 0
        }
      }
    }
  }
</script>

<template lang="pug">
  .achivement(
    :class = 'classnames'
    )
    .achivement__wrap
      .achivement__heading
        |スタンプ
        strong
          |{{ n }}
        |個を達成しました！
      .achivement__text
        |{{ getText }}
</template>

<style lang="scss">
  .achivement {
    width: 100%;
    height: 0;
    box-sizing: border-box;
    overflow: hidden;
    &.is-shown {
      border: 3px solid $primary-color;
      transition-duration: 0.2s;
      transition-property: height;
      @include l-more-than-mobile {
        height: 98px;
      }
      @include l-mobile {
        height: 75px;
      }
    }
    &__wrap {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
    &__heading {
      line-height: 1;
      margin-bottom: 5px;
      color: $primary-color;
      @include fontSizeAll(24, 16);
      font-weight: 700;
      strong {
        @include fontSizeAll(24, 20);
      }
    }
    &__text {
      @include fontSizeAll(14, 12);
    }
  }
</style>
